import $ from 'jquery';
import 'signalr';
import app from './app';
import SignalrHub from './signalr-hub';
import PersistentConnector from './persistent-connector';

class SignalR {

    constructor() {
        this.connection = $.hubConnection();
        this.connection.logging = true;
        this.hubs = {};
        this.initConnectionPromise = null;
        this.initConnectionResolve = null;
        this.isInitConnectionResolved = false;
        this.reconnect = this.reconnect.bind(this);

        this.connector = new PersistentConnector(this.reconnect, {name: 'SignalR'});
        this.init();
    }

    init() {
        this.connection.starting(() => {
            console.log('SignalR starting');
        });
        this.connection.reconnecting(() => {
            console.log('SignalR reconnecting');
        });
        this.connection.reconnected(() => {
            console.log('SignalR reconnected');
        });
        this.connection.disconnected(() => {
            console.log('SignalR disconnected');
            //inner signalr logic of connection persistency failed so we will try our
            this.connector.recover();
        });

        this.connection.error((error) => {
            console.log('SignalR connection error');
        });
    }

    onConnect() {
        if (!this.isInitConnectionResolved) {
            this.isInitConnectionResolved = true;
            this.initConnectionResolve();
        }
        this.connector.onConnect();
    }

    connect() {
        if (this.initConnectionPromise === null) {
            this.initConnectionPromise = new Promise((resolve) => {
                //expose resolve function
                //for handling a situation when first attempt was failed
                //in this case we want to resolve the promise anyway as soon as connection is established
                this.initConnectionResolve = resolve;
                this.connection.start().done(() => {
                    this.onConnect();
                });
            })
        }
        return this.initConnectionPromise;
    }

    reconnect() {
        this.connection.start().done(() => {
            this.onConnect();
        });
    }

    getHub(hubName) {
        if (!(hubName in this.hubs)) {
            this.hubs[hubName] = new SignalrHub(this.connection, hubName);
        }
        return this.hubs[hubName];
    }
}

let instance = new SignalR();
export default instance;




// WEBPACK FOOTER //
// ./app/general/js/signalr.js